var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { REGEX } from '../constants';
import { getPropsByKeyPath, parseStringToObj } from './objHelpers';
import { E_GENDER } from 'src/services/cases/types';
var decapsulateI18n = function (str, obj) {
    if (obj === void 0) { obj = {}; }
    if (str.match(REGEX.IS_I18N_KEYMAP_WITH_PARAMS)) {
        var isMatchingObjRegex = REGEX.OBJECT.exec(str);
        var indexOfObj = isMatchingObjRegex ? isMatchingObjRegex.index : null;
        if (indexOfObj) {
            return {
                keyPath: str.substring(3, indexOfObj - 3),
                params: __assign(__assign({}, obj), parseStringToObj(str.substring(indexOfObj, str.length - 1))),
            };
        }
        return null;
    }
    else if (str.match(REGEX.IS_I18N_KEYMAP_NO_PARAMS)) {
        return {
            keyPath: str.substring(3, str.length - 2),
            params: obj,
        };
    }
    else if (str) {
        return {
            keyPath: str,
            params: obj,
        };
    }
};
export var resolveKeyPathString = function (keyPathBase, i18n, objParams) {
    var isKeyPath = keyPathBase.match(REGEX.KEY_PATH);
    var decapsulatedKeyPath = decapsulateI18n(keyPathBase, objParams);
    // Warning if keyPath don't always have dot or $ in it could conduct to error
    // don't start with "t('" because it's indicate that a keyPath Translation
    if (!isKeyPath && !keyPathBase.startsWith("t('")) {
        return keyPathBase;
    }
    if (decapsulatedKeyPath) {
        var keyPath = decapsulatedKeyPath.keyPath, params = decapsulatedKeyPath.params;
        var keyPathResult = Object.entries(params).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            return acc.replace("$".concat(key), value);
        }, keyPath);
        if (i18n) {
            var keyValueMapResult = getPropsByKeyPath(i18n.keyValueMap, keyPathResult);
            if (keyValueMapResult) {
                return keyValueMapResult;
            }
            var componentsResult = getPropsByKeyPath(i18n.components, keyPathResult);
            if (componentsResult) {
                return componentsResult;
            }
            var modulesResult = getPropsByKeyPath(i18n.modules, keyPathResult);
            if (modulesResult) {
                return modulesResult;
            }
            console.warn('Text not Found in i18n config :', i18n, 'with Keypath: ', keyPathBase);
            return null;
        }
        else {
            return keyPathResult;
        }
    }
    else {
        console.warn('Text not Found in i18n config :', i18n, 'with Keypath: ', keyPathBase);
        return null;
    }
};
export var getGenderLabel = function (i18n, genderValue) {
    switch (genderValue) {
        case E_GENDER.MALE:
            return getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.modals.identityValidation.genderOptions.male");
        case E_GENDER.FEMALE:
            return getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.modals.identityValidation.genderOptions.female");
        default:
            return getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.modals.identityValidation.genderOptions.other");
    }
};
